import { render } from "./SoundSwitcher.vue?vue&type=template&id=1d68e316"
import script from "./SoundSwitcher.vue?vue&type=script&lang=js"
export * from "./SoundSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "D:\\p2h_proj\\californiamilkprocessorboard\\markup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__